import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useIsFeatureEnabled } from "../_app/featureFlags";
import { Scripts } from "../scripts/Scripts";

export const Route = createFileRoute("/scripts")({
  component: ScriptsRoute,
});

function ScriptsRoute() {
  const isRunServiceScriptsEnabled = useIsFeatureEnabled("runServiceScripts");

  if (!isRunServiceScriptsEnabled) {
    return <Navigate to="/" />;
  }

  return <Scripts />;
}
